import { createScript } from '../create-script';
import { getScriptBySrc } from '../get-script-by-src';

const POLYFILLS_LOADED_CB = 'polyfillsLoaded';

// eslint-disable-next-line @typescript-eslint/no-namespace
declare global {
	interface Window {
		polyfillsLoadedFlag: boolean;
		polyfillsLoadedCallbacks: (() => void)[];
		[POLYFILLS_LOADED_CB]: () => void;
	}
}

const polyfillesLoadedFn = () => {
	if (window.polyfillsLoadedCallbacks.length) {
		for (let i = 0; i < window.polyfillsLoadedCallbacks.length; i++) {
			window.polyfillsLoadedCallbacks[i]();
		}
	}
	window.polyfillsLoadedFlag = true;
};

window.polyfillsLoadedFlag = false;
window.polyfillsLoadedCallbacks = window.polyfillsLoadedCallbacks || [];
window.polyfillsLoaded = window.polyfillsLoaded || polyfillesLoadedFn;

export const OPTEN_BASE_POLYFILLS = [
	'es6',
	'CustomEvent',
	'fetch',
	'HTMLPictureElement',
];

export const OPTEN_MAIN_POLYFILLS = [
	...OPTEN_BASE_POLYFILLS,
	'String.prototype.padStart',
	'String.prototype.padEnd',
];

export function loadPolyfill(
	cb: () => void,
	features: string[] = OPTEN_MAIN_POLYFILLS
): void {
	const src = `https://cdn.polyfill.io/v2/polyfill.min.js?features=${features.join(
		','
	)}&flags=gated&callback=${POLYFILLS_LOADED_CB}`;

	window.polyfillsLoadedCallbacks.push(cb);

	const script = getScriptBySrc(src);

	if (script) {
		if (window.polyfillsLoadedFlag) {
			cb();
		}
	} else {
		document.head.appendChild(createScript(src, cb));
	}
}
